<template>
    <v-card width="100%">
        <v-simple-table fixed-header xs12>
            <template v-slot:default>
                <thead>
                <tr>
                    <th class="text-left"><h3>Address</h3></th>
                    <th class="text-left"><h3>Price</h3></th>
                    <th class="text-right"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="home in homes" :key="home.id">
                    <td class="text-left subtitle-1 xs4">
                        {{home.Address.Street}}, {{home.Address.City}} {{home.Address.State}}
                    </td>
                    <td class="text-left xs4">{{home.Price | currency}}</td>
                    <td class="text-right xs4">
                        <RouterLink :to="'/properties/details/' + home.id" class="router-link">
                            <v-btn icon>
                                <v-icon color="rgb(0, 188, 212)">mdi-format-list-bulleted-square</v-icon>
                            </v-btn>
                        </RouterLink>
                        <v-btn icon @click.prevent="deleteProperty(home)" color="red">
                            <v-icon color="red">mdi-delete</v-icon>
                        </v-btn>
                    </td>
                </tr>
                </tbody>
            </template>
        </v-simple-table>
    </v-card>
</template>

<script>
    import { db } from "@/firebase"
    import { authService } from "@/services/AuthService";
    import { collection, query, getDocs, deleteDoc, doc, where, orderBy, limit } from 'firebase/firestore';

    export default {
        name: "PropertyList",
        data: () => ({
            homes: [],
            authService: authService
        }),
        mounted() {
            if (this.authService.userId) {
                this.initializeDataBind();
            } else {
                this.$root.$on('loginComplete', this.initializeDataBind);
            }      
        },
        methods: {
            deleteProperty: async function (home) {
                await deleteDoc(doc(db, "properties", home.id));
                await this.initializeDataBind();
            },
            initializeDataBind: async function() {
                const propCol = collection(db, 'properties')
                const propQuery = query(propCol, where('UserId', "==", this.authService.email), orderBy('UpdatedAt', 'desc'), limit(300))
                const propSnapshot = await getDocs(propQuery);
                const data = propSnapshot.docs.map((item) => { 
                    let doc = item.data()
                    doc.id = item.id;
                    return doc
                });
                this.homes = data;
            }
        }
    }
</script>

<style scoped>
    .router-link {
        text-decoration: none;
    }
</style>